import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

interface LoginProps {
  onSignup: () => void;
  onForgotPassword: () => void;
}

const Login: React.FC<LoginProps> = ({ onSignup, onForgotPassword }) => {
  const { login, isLoading } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    try {
      await login(formData.email, formData.password);
    } catch (error: any) {
      setError(error.message || 'Invalid email or password');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <img src="/images/uet-logo.png" alt="UET Logo" className="main-logo" />
            </div>
            <h1>Clean UET</h1>
            <p className="tagline">Welcome back!</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-alert">{error}</div>}
            
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                className="form-input"
              />
            </div>

            <button type="submit" disabled={isLoading} className="submit-button">
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <p className="forgot-password">
            <a href="#" onClick={(e) => { e.preventDefault(); onForgotPassword(); }}>
              Forgot your password?
            </a>
          </p>
          
          <p className="signup-link">
            Don't have an account? <a href="#" onClick={(e) => { e.preventDefault(); onSignup(); }}>Sign up here</a>
          </p>
          
          <div className="credits">
            <div className="credits-logos">
              <img src="/images/byte-bandit.jpg" alt="ByteBandits" className="credits-logo byte-bandits-logo" />
              <span className="credits-separator">×</span>
              <img src="/images/uet-logo.png" alt="UET" className="credits-logo uet-small-logo" />
            </div>
            <p>Developed by <a href="https://www.instagram.com/byt_ebandits/" target="_blank" rel="noopener noreferrer" className="bytebandits-link"><strong>ByteBandits</strong></a></p>
            <p className="university">UET • University of Engineering and Technology</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;